import { reactive, ref } from '@nuxtjs/composition-api'
import Comment from '@/classes/Comment'
import { isArray, isObject } from 'typechecker'
import { GetStoreCommentsResponse } from '@/types/ggo-api/responses'
import ggoApi from '@/modules/ggo-api'

export default function () {
  const storeId = ref<number>()

  const comments = reactive({
    value: null as {
      response?: GetStoreCommentsResponse,
      comments: Comment[]
    } | null,
    error: null as string | null,
    isFetching: false as boolean,
  })
  const page = ref<number>(1)
  const isAllLoaded = ref(false)

  const setStoreId = (id: number) => {
    storeId.value = id
    reset()
  }

  const getStoreComments = async () => {
    if (!storeId.value) return

    if (!comments.value) {
      comments.value = {
        comments: [],
      }
    }

    comments.error = null
    comments.isFetching = true

    const params = {
      storeId: storeId.value,
      page: page.value,
    }
    const { success, data, error } = await ggoApi.getStoreComments(params)

    if (error) {
      comments.error = error

      if (error === 'Network Error') comments.error = '網路斷線，連線後點擊重試'
      else comments.error = '系統錯誤，點擊重試'
    } else if (success && data) {
      if (!isObject(data)) throw new TypeError('`comment response` must be an object!')
      comments.value.response = data
      if (isArray(data?.ordersRating?.data)) {
        const _comments = data.ordersRating.data.map(d => new Comment(d))
        comments.value.comments = [...comments.value.comments, ..._comments]
      }
      if (data.ordersRating.last_page === page.value) {
        isAllLoaded.value = true
      }
    }

    comments.isFetching = false
  }

  const loadMore = async () => {
    if (isAllLoaded.value) return
    // 以防 race condition
    if (comments.isFetching) return

    /* eslint-disable-next-line camelcase */
    if (comments.value?.response?.ordersRating.last_page) {
      if (page.value < comments.value.response.ordersRating.last_page) {
        page.value++

        await getStoreComments()
      }
    }
  }

  const reset = () => {
    comments.value = null
    page.value = 1
  }

  return {
    storeId,
    comments,
    page,
    isAllLoaded,

    setStoreId,
    loadMore,
    getStoreComments,

    reset,
  }
}
